/**
 * Self-registering tour registry.
 * Each tour file calls registerTour() to add itself.
 * Adding a new tour = one new file + one import in tours/index.js.
 */

const registry = {};

/**
 * Register a tour configuration.
 * @param {Object} config
 * @param {string} config.id - Unique tour identifier
 * @param {string|RegExp} config.pathPattern - URL path pattern to match
 * @param {Function} config.getSteps - Returns array of Shepherd step configs
 * @param {string} config.label - Human-readable tour name
 */
export function registerTour(config) {
  registry[config.id] = config;
}

/**
 * Find a registered tour for the given pathname.
 * @param {string} pathname - Current URL pathname
 * @returns {Object|undefined} Tour config or undefined
 */
export function getTourForPath(pathname) {
  return Object.values(registry).find(config =>
    typeof config.pathPattern === 'string'
      ? pathname === config.pathPattern || pathname.startsWith(config.pathPattern + '/')
      : config.pathPattern.test(pathname)
  );
}

/**
 * Get a tour by its ID.
 * @param {string} id
 * @returns {Object|undefined}
 */
export function getTourById(id) {
  return registry[id];
}
